
import { Link } from 'react-router-dom';
import Heading from '../components/heading'
import Marquee from "react-fast-marquee";
import { useSelector } from 'react-redux';
import { retrunAssets } from '../utils/getAssets';
import { useState } from 'react';
const OurPartners = () => {

   

    const [loading, ] = useState(false)

    const state = useSelector(state => state.homepage)
    const title = state.data?.properties?.title
    const description = state.data?.properties?.description
    const partners = state.data?.properties?.mainPartnersImage?.items.map(d => {
        return {
            text: d?.content?.properties?.title,
            img: retrunAssets(d?.content?.properties?.image[0].url)
        }
    })
  
    const data  = state.data?.properties?.secondaryPartnersImage?.map(d => {
        return retrunAssets(d?.url)
    }
    )
    return (
        <div  className="relative bg-[#f3f3f3] text-black flex  flex-col items-start justify-center ">
            <div className=" 2xl:max-w-full w-full  min-h-[20rem] flex flex-col items-center justify-center p-6 md:p-4  gap-3">
                <Heading name="Our Partners" />
                {
                    loading ?
                        <div className=" bg-gray-200/30 h-2 animate-pulse  text-center"></div>
                        :
                        <h1 className="text-3xl md:text-4xl font-bold text-center">{title}</h1>
                }
                {
                    loading ?
                        <p className="w-full text-center animate-pulse bg-gray-500 h-10 rounded-full font-bold md:w-[30rem] 2xl:w-[55rem] 2xl:text-5xl "></p>
                        :
                        <p className=" 2xl:text-lg  md:max-w-[53%] text-center w-full">{description}</p>
                }
                {/* <Link to={'/our partners'} className='p-2 px-3  border w-fit rounded-sm my-3 font-bold text-xs 2xl:text-sm text-[#0039cb] border-[#0039cb] flex items-center gap-1'>View All</Link> */}


                <div className='w-full flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 md:py-6'>
                    {
                        partners?.map((partner, index) => (
                            <div key={index} className="w-full flex-1 h-full  flex items-center justify-center gap-2 bg-inherit">
                                <img src={partner.img} alt="photo" className=' h-auto object-contain bg-inherit' width={50} height={500} />
                                <p className='text-[#B44444] text-xs sm:text-sm font-bold md:text-lg whitespace-nowrap'>{partner.text}</p>
                            </div>
                        ))
                    }
                </div>



            </div>
            <div className='w-full bg-white my-5   h-[11rem] flex items-center justify-center'>
                <Marquee speed={150}>
                    <div className="flex gap-[5rem] pr-[5rem] md:gap-[10rem] md:pr-[8rem] w-full   overflow-x-auto  p-2 mt-2 ">
                        {
                            data?.map((item, i) => (
                                <div key={i} className="w-full flex-1 max-w-[205px] flex justify-center items-center">
                                    <img src={item} alt="photo" width={100} height={500} className='w-full h-auto bg-inherit object-contain' />
                                </div>
                            ))
                        }
                    </div>
                </Marquee>
            </div>

        </div>
    )
}

export default OurPartners